class CartSellingPlanSelect extends HTMLElement {
  constructor() {
    super()
    this.selling_plan_tab_one_time = this.querySelector("input.sellingplan_tab.one-time")
    this.cart = document.querySelector("cart-items") || document.querySelector("cart-drawer-items");
    this.selling_plan_select = this.querySelector(".selling_plan-select")
    this.selling_plan_select.addEventListener("change", this.changeCartSellingPlan.bind(this))
    this.selling_plan_tab_one_time.addEventListener("input", this.changeCartSellingPlan.bind(this));
    this.selectedSellingPlanValue = null;
    if (window.location.href.indexOf("/products") !== -1) {
      this.setHiddenInputValue()
    }
  }
  get goodieIds() {
    const ids = this.dataset.addGoodies
      ? this.dataset.addGoodies.split(",").filter(id => id.trim() !== "")
      : [];
    return ids;
  }
  get selectedPlan() {
    return this.dataset.selectedPlan;
  }

  get itemsToRemove() {
    const ids = this.dataset.cartGoodies
      ? this.dataset.cartGoodies.split(",").filter(id => id.trim() !== "")
      : [];
    return ids;
  }

  get removeGoodies() {
    return this.dataset.removeGoodies === "true"
  }

 async connectedCallback() {
    this.cart = await getCartElement();
    if (!this.cart) {
      return;
    }

    // Shopify Events abonnieren
    this.unsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event) this.checkGoodieProducts(event);
    });

    // Initial prüfen
    this.checkGoodieProducts();
  }
  disconnectedCallback(){
    this.unsubscriber()
  }
  createAddArray() {
    let add_items = []
    let cart_items = this.cart.querySelectorAll(".cart-item")

    cart_items.forEach(item => {
      let variant_id = item.dataset.variantId
      if (!item.querySelector("special-product")) {
        let quantity = item.querySelector('quantity-popover input[type="number"]') ? item.querySelector('quantity-popover input[type="number"]').value : 1

        let selling_plan_ids
        let new_selling_plan_id = null

        if (item.dataset.sellingPlanIds != undefined) {
          selling_plan_ids = item.dataset.sellingPlanIds.split(",")
        }

        if (this.selectedSellingPlanValue != null && item.dataset.sellingPlanIds != undefined) {
          new_selling_plan_id = selling_plan_ids[this.selectedSellingPlanValue]
          if (new_selling_plan_id == undefined) {
            new_selling_plan_id = null
          }
        }

        let add_item = {
          id: variant_id,
          quantity,
          selling_plan: new_selling_plan_id
        }
        if (item.dataset.properties && item.dataset.properties.trim() !== "") {
           const props = item.dataset.properties;
          try {
            const parsedProps = JSON.parse(props);
            if (parsedProps && typeof parsedProps === "object" && !Array.isArray(parsedProps)) {
              add_item.properties = parsedProps;
            }
          } catch (e) {
            console.error("Error parsing data-properties:", e);
          }
        }
        add_items.push(add_item)
      }
      else if (item.querySelector("special-product")) {
        if (item.querySelector("special-product input[type='checkbox'").checked) {
          let add_item = {
            id: variant_id,
            quantity: 1
          }
          add_items.push(add_item)
        }
      }

    })
    if (this.selectedSellingPlanValue != null && this.goodieIds.length) {
      this.goodieIds.forEach(id => {
        add_items.push({
          id: id,
          quantity: 1,
          properties: {
            _isGoodie: "sub"
          }
        })
      })
    }
    add_items.reverse()
    let add_arrays = splitArray(add_items, 20)
    return add_arrays
  }

  changeCartSellingPlan(event) {
    if (event.target.closest(".sellingplan_tab")?.classList.contains("one-time")) {
      this.selectedSellingPlanValue = null;
    }
    else {
      this.selectedSellingPlanValue = event.target.value
    }

    if (this.selectedSellingPlanValue != null) {
      this.selectedSellingPlanValue = Number(this.selectedSellingPlanValue)

      const d = new Date();
      const cookieExpire = d.setTime(d.getTime() + (24 * 60 * 60 * 1000));
      document.cookie = `active_selling_plan=${event.target.value};${cookieExpire};`
    }


    // Change Hidden Input when on PDP 
    if (window.location.href.indexOf("/products") !== -1) {
      this.setHiddenInputValue()
    }
    const addArrays = this.createAddArray();


    window.sessionStorage.setItem("add-selling-plan-arrays", JSON.stringify(addArrays))


    fetch(window.Shopify.routes.root + 'cart/clear.js')
      .then(response => {
        addArrays.forEach(array => {
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body:
              JSON.stringify({
                items:
                  array,
                sections: this.cart.getSectionsToRender().map((section) => section.section),
                sections_url: window.location.pathname


              })
          })
            .then(response => {
              return response.text()
            })
            .then((state) => {
              const parsedState = JSON.parse(state);
              if (parsedState.errors) {
                console.error("Error updating cart selling plan:", parsedState.errors);
                this.container.classList.remove('cart-disabled');
                return;
              }
              this.cart.renderContents(parsedState);
              document.dispatchEvent(new CustomEvent('selling-plan::changed'))
            });
        })
      }

      )
  }

  // If on PDP change hidden input value
  setHiddenInputValue() {
    let selling_plan_input = document.querySelector("input[name='selling_plan']")
    if (this.querySelector(".sellingplan_tab.one-time:checked") && selling_plan_input != undefined) {
      selling_plan_input.value = ""
    }
    else if (selling_plan_input != undefined) {
      selling_plan_input.value = document.querySelector(".selling_plan_ids")?.dataset.sellingPlanIds.split(",")[this.selling_plan_select.value]
    }
  }

  async removeFreeProducts() {
    if (this.itemsToRemove.length > 0) {
      let cartAction = "cart/update.js"
      const updates = {};
      this.itemsToRemove.forEach(id => {
        updates[id] = 0;
      });
      await fetch(window.Shopify.routes.root + cartAction, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body:
          JSON.stringify({
            updates,
            sections: this.cart.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
          })
      }).then((response) => response.text()).then((state) => {
        const parsedState = JSON.parse(state)
        if(parsedState.errors){
          console.error(parsedState.errors)
          return
        }
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');
           this.cart?.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        this.cart.renderContents(parsedState);
      })
    }
  }
  async checkGoodieProducts() {
      if ((this.selectedPlan == "null" || this.removeGoodies == true) && this.itemsToRemove.length > 0) {
        await this.removeFreeProducts()
      } else if (this.selectedPlan != "null" && this.goodieIds && this.goodieIds.length > 0) {
        if(!this.cart) this.cart = document.querySelector("cart-items") || document.querySelector("cart-drawer-items");
        const goodies = []
        this.goodieIds.forEach(id => {
          goodies.push({
            id: id,
            quantity: 1,
            properties: {
              _isGoodie: "sub"
            }
          })
        })
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body:
            JSON.stringify({
              items: goodies,
              sections: this.cart.getSectionsToRender().map((section) => section.section),
              sections_url: window.location.pathname
            })
        })
          .then(response => {
            return response.text()
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            if (parsedState.errors) {
              console.error("Error updating cart selling plan:", parsedState.errors);
              this.container.classList.remove('cart-disabled');
              return;
            }
            this.cart.renderContents(parsedState);
          });
      }
  }
  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML;
  }

  close() {
    this.cart.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    this.cart.querySelector("information-popup[open]")?.removeAttribute("open");
  }

}
customElements.define("cart-selling-plan-select", CartSellingPlanSelect)

function splitArray(array, chunkSize) {
  let result = [];

  for (let i = 0; i < array.length; i += chunkSize) {
    let chunk = array.slice(i, i + chunkSize);
    result.push(chunk);
  }

  return result;
}


class TabComponentSubscription extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", (event) => {
      if (event.target.dataset.openTab) {
        const tabId = event.target.dataset.openTab;
        const oldTabs = document.querySelectorAll(".tab__content.active");

        oldTabs.forEach(ele => ele.classList.remove("active"));
        const tabElements = document.querySelectorAll(`#open-${tabId}`);
        tabElements.forEach(ele => ele.classList.add("active"));
      }
    });
  }
}

customElements.define("tab-component-subscription", TabComponentSubscription);

async function getCartElement() {
  const cartItems = document.querySelector("cart-items");
  const cartDrawerItems = document.querySelector("cart-drawer-items");

  if (cartItems) {
    await customElements.whenDefined("cart-items");
    return cartItems;
  }

  if (cartDrawerItems) {
    await customElements.whenDefined("cart-drawer-items");
    return cartDrawerItems;
  }

  console.warn("No cart-items or cart-drawer-items element found in DOM!");
  return null;
}
